import { render, staticRenderFns } from "./figures.vue?vue&type=template&id=1ba8ca10&scoped=true&"
import script from "./figures.vue?vue&type=script&lang=js&"
export * from "./figures.vue?vue&type=script&lang=js&"
import style0 from "./figures.vue?vue&type=style&index=0&id=1ba8ca10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba8ca10",
  null
  
)

export default component.exports